import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon/icon';

function Checkbox(props) {
    const containerClassNames = ['floating-label-checkbox'].concat(props.additionalContainerClasses);

    if (props.disabled) {
        containerClassNames.push('floating-label-checkbox--disabled');
    }

    return (
        <label className={containerClassNames.join(' ')}>
            <span className="floating-label-checkbox__checkbox-container">
                <input
                    className="floating-label-checkbox__real-checkbox"
                    type="checkbox"
                    name={props.name}
                    onChange={e => props.onChange(e.target.checked, props.name, props)}
                    disabled={props.disabled}
                    checked={props.checked}
                    value={props.label}
                />
                <span className="floating-label-checkbox__styled-checkbox" />
            </span>
            <span className="floating-label-checkbox__label">
                {props.label}
            </span>
            {props.icon && <Icon iconName={props.icon}></Icon>}
        </label>
    );
}

Checkbox.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    additionalContainerClasses: PropTypes.array,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
};

Checkbox.defaultProps = {
    additionalContainerClasses: [],
    disabled: false,
};

export { Checkbox };
